import { DashboardConfig } from '@/interfaces/custom-dashboard'

export default {
  namespaced: true,

  state: {
    currentDashboard: null
  },

  getters: {
    currentExportedData (state: any) {
      if (!state.currentDashboard) {
        return []
      }

      return (state.currentDashboard as DashboardConfig).widgets.filter(widget => ['table', 'table-by-value'].includes(widget.metadata.type))
        .map(widget => ({ name: widget.metadata.title, data: widget.value }))
    }
  },

  mutations: {
    setCurrentDashboard (state: any, dashboard: DashboardConfig) {
      state.currentDashboard = dashboard
    }
  }
}
